/**
 * Sidebar Content Component
 * Combines header, navigation, and footer
 */

import { TooltipProvider } from '@spcc/uikit'
import type { SidebarContentProps } from '../types'
import { SidebarHeader } from './sidebar-header'
import { SidebarNav } from './sidebar-nav'
import { SidebarFooter } from './sidebar-footer'

export function SidebarContent({ collapsed = false, onNavigate }: SidebarContentProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <div className="relative flex flex-col h-full">
        {/* Watermark Logo */}
        {!collapsed && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
            <img
              src="/spcc-logo.png"
              alt=""
              className="w-48 h-48 object-contain opacity-[0.03]"
            />
          </div>
        )}
        <SidebarHeader collapsed={collapsed} />
        <SidebarNav collapsed={collapsed} onNavigate={onNavigate} />
        <SidebarFooter collapsed={collapsed} onNavigate={onNavigate} />
      </div>
    </TooltipProvider>
  )
}
